import { createSkiffBoat } from '../boat/document.ts';
import { planningFeelFromBoat } from '../boat/planning.ts';
import type { BoatDocument } from '../boat/types.ts';
import { createDefaultDebugDefaults } from '../debugDefaults/migrate.ts';
import type { DebugDefaultsDocument } from '../debugDefaults/types.ts';
import { DEFAULT_WIND_FEEL } from '../environment/wind.ts';
import type { RingMode, TurnFeel } from '../turnFeel.ts';

export type BotFeelInput = {
  /** Hull the seat sails. Defaults to the Skiff. */
  boat?: BoatDocument;
  /**
   * Session knobs (tax, harshness, wind). Defaults to the factory debug defaults, which are not
   * the shipped `defaults.json` (harshness differs); the runner passes the shipped file.
   */
  session?: Pick<DebugDefaultsDocument, 'crashHarshness' | 'turnTax' | 'wind'>;
  ringMode?: RingMode;
};

/**
 * The `TurnFeel` a live seat would have with this hull and session: reach, radius, and bow come
 * from the boat (as `GameScene.installSeat` copies them), tax / harshness / wind from the session.
 */
export function botTurnFeel(input: BotFeelInput = {}): TurnFeel {
  const boat = input.boat ?? createSkiffBoat();
  const session = input.session ?? createDefaultDebugDefaults();
  const hull = planningFeelFromBoat(boat);

  return {
    radius: hull.movementRadius,
    reach: hull.reach,
    ringMode: input.ringMode ?? 'off',
    planingSpeedKmh: boat.planingSpeedKmh,
    bowOffsetPx: hull.bowOffsetPx,
    crashHarshness: session.crashHarshness,
    turnTax: session.turnTax,
    windFeel: { ...DEFAULT_WIND_FEEL, ...session.wind, enabled: true },
  };
}
